import { CheckCircleOutlined, CloseCircleOutlined } from "@ant-design/icons"
import { Alert, Button, Card, Form, Input } from "antd"
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { createRoleWithPermissions, getPermissions } from "../../store/slices/roleSlice";
import Checkbox from "antd/es/checkbox/Checkbox";

const AddRole = () => {
    const [form] = Form.useForm();
    const dispatch = useDispatch();
    const [alertMessage, setAlertMessage] = useState("");
    const [alertType, setAlertType] = useState("success");
    const [buttonLoading, setButtonLoading] = useState(false);
    const [checkedList, setCheckedList] = useState([]);
    useEffect(() => {
        dispatch(getPermissions())
    }, [dispatch])
    const { permissions } = useSelector((state) => state?.role)
    const groupedPermissions = permissions?.data?.reduce((acc, perm) => {
        const type = perm.type || "other";

        if (!acc[type]) {
            acc[type] = [];
        }

        acc[type].push({
            label: perm.name
                .split("_")
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(" "),
            value: perm._id
        });

        return acc;
    }, {});
    const onSubmit = async (values) => {
        setButtonLoading(true);
        try {
            await new Promise(resolve => setTimeout(resolve, 1000));
            const resultAction = await dispatch(createRoleWithPermissions(values))
            if (createRoleWithPermissions.fulfilled.match(resultAction)) {
                setAlertMessage(resultAction?.payload?.message || 'Role permission created successfully');
                setAlertType('success');
                form.resetFields();
                setTimeout(() => {
                    setAlertMessage("")
                }, 4000)
            } else {
                console.log(resultAction?.payload)
                setAlertMessage(resultAction?.payload?.error || 'Error creating role');
                setAlertType('error');
            }
        } catch (error) {
            setAlertMessage('Error creating role');
            setAlertType('error');
        } finally {
            setButtonLoading(false);
        }
    }
    return (
        <div>
            <h1 style={{ marginBottom: 24 }}>Role</h1>
            <Card title="Add Role" style={{ marginBottom: 16 }}>
                {alertMessage && (
                    <Alert
                        message={alertMessage}
                        type={alertType}
                        showIcon
                        icon={alertType === 'success' ? <CheckCircleOutlined /> : <CloseCircleOutlined />}
                        closable
                        onClose={() => setAlertMessage('')}
                        style={{
                            marginBottom: 24,
                            borderRadius: '8px',
                        }}
                    />
                )}
                <Form
                    layout="vertical"
                    onFinish={onSubmit}
                    form={form}
                    // initialValues={{
                    //     gender: '',
                    //     availability: [{}],
                    //     working_hours: [{}]
                    // }}
                >
                    <Form.Item
                        label="Role Name"
                        name="role_name"
                        rules={[{ required: true, message: 'Please input role name!' }]}
                    >
                        <Input placeholder="Enter role name" />
                    </Form.Item>
                    {/* <Form.Item
                        label="Permissions"
                        name="permissionIds"
                        rules={[{ required: true, message: 'Please select permission!' }]}
                    >
                        <Checkbox.Group
                            options={options}
                            value={checkedList}
                            onChange={setCheckedList}
                        />
                    </Form.Item> */}
                    <Form.Item
                        label="Permissions"
                        name="permissionIds"
                        rules={[{ required: true, message: 'Please select permission!' }]}
                    >
                        {groupedPermissions &&
                            Object.keys(groupedPermissions).map((type) => (
                                <div key={type} style={{ marginBottom: 16 }}>
                                    <h3 style={{ textTransform: "capitalize" }}>
                                        {type}
                                    </h3>

                                    <Checkbox.Group
                                        options={groupedPermissions[type]}
                                        value={checkedList.filter(val =>
                                            groupedPermissions[type].some(p => p.value === val)
                                        )}
                                        onChange={(list) => {
                                            const otherValues = checkedList.filter(
                                                (val) => !groupedPermissions[type].some(p => p.value === val)
                                            );

                                            const newList = [...otherValues, ...list];

                                            setCheckedList(newList);
                                            form.setFieldsValue({ permissionIds: newList });
                                        }}
                                    />
                                </div>
                            ))}
                    </Form.Item>
                    <Form.Item>
                        <Button
                        type="primary"
                        htmlType="submit"
                        loading={buttonLoading}
                        style={{ marginTop: 16 }}
                        >
                        Submit
                        </Button>
                    </Form.Item>
                </Form>
            </Card>
        </div>
    )
}

export default AddRole